import React from 'react';
import PropTypes from 'prop-types';
import Loader from '../../../../checkout/components/loader/Loader';
import ClickableDiv from '../../../../ui_kit/clickable_div/ClickableDiv';
import styles from './IngredientTooltip.module.sass';
import closeIcon from '../../../../../images/icons/close.svg';

function IngredientTooltip(props) {
  const {
    ingredient, definition, loading, closePopup, error,
  } = props;

  return (
    <div className={styles.box}>
      <div className={styles.header}>
        {ingredient}
        <ClickableDiv className={styles.close} onClick={closePopup}>
          <img src={closeIcon} alt="close" />
        </ClickableDiv>
      </div>
      <div className={styles.body}>
        { loading && <Loader /> }
        { error && (error !== 'Not found') && (
          <div className={styles.definition}>Ingredient definition currently not available.</div>
        )}
        { error === 'Not found' && (
          <div className={styles.definition}>Ingredient definition not found.</div>
        )}
        { !loading && (
          <div className={styles.definition}>{definition}</div>
        )}
        <div className={styles.copyright}>POWERED BY CLEARFORME</div>
      </div>
    </div>
  );
}

IngredientTooltip.propTypes = {
  ingredient: PropTypes.string.isRequired,
  definition: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  closePopup: PropTypes.func.isRequired,
  error: PropTypes.string,
};

IngredientTooltip.defaultProps = {
  definition: undefined,
  error: undefined,
};

export default IngredientTooltip;
